export const MAX_FILE_SIZE_MB = 8;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const MAX_DOCUMENTS = 20;
export const MAX_DOCUMENTS_TOTAL_SIZE_MESSAGE =
  "La suma de todos los archivos, incluida la evidencia de especialidad, debe ser menor de 8 MB. Reduzca el tamaño o elimine archivos.";
export const ALLOWED_FILE_TYPES = ["application/pdf", "image/jpeg", "image/png"];
export const SPECIALITY_EVIDENCE_KEY = "specialtyDegreeMsp";
export const isSpecialityEvidenceDocument = (document) =>
  document?.requirementKey === SPECIALITY_EVIDENCE_KEY;
export const getSpecialityEvidenceDocuments = (documents = []) =>
  documents.filter(isSpecialityEvidenceDocument);
export const getSupportingDocuments = (documents = []) =>
  documents.filter((document) => !isSpecialityEvidenceDocument(document));
export const buildDocumentKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;
export const getDocumentsTotalSize = (items = []) =>
  items.reduce((total, item) => total + Number(item?.size || 0), 0);

export const prepareDocumentSelection = (
  current,
  files,
  { maxSupportingDocuments = 0, requirementKey = "" } = {},
) => {
  const known = new Set(
    current.map((document) =>
      document.file ? buildDocumentKey(document.file) : document.id,
    ),
  );
  const uniqueFiles = files.filter((file) => {
    const key = buildDocumentKey(file);
    if (known.has(key)) return false;
    known.add(key);
    return true;
  });
  const invalid = uniqueFiles.find((file) => !ALLOWED_FILE_TYPES.includes(file.type) || file.size <= 0);
  if (invalid) return { error: `El archivo ${invalid.name} debe ser un PDF, JPG o PNG no vacío.` };
  if (getDocumentsTotalSize(current) + getDocumentsTotalSize(uniqueFiles) >= MAX_FILE_SIZE_BYTES) {
    return { error: MAX_DOCUMENTS_TOTAL_SIZE_MESSAGE };
  }
  if (current.length + uniqueFiles.length > MAX_DOCUMENTS) {
    return { error: `Puede adjuntar un máximo de ${MAX_DOCUMENTS} archivos en total.` };
  }
  const isSpecialityEvidence = requirementKey === SPECIALITY_EVIDENCE_KEY;
  const supportingDocumentsCount = getSupportingDocuments(current).length;
  if (
    !isSpecialityEvidence &&
    maxSupportingDocuments &&
    supportingDocumentsCount + uniqueFiles.length > maxSupportingDocuments
  ) {
    return {
      error: `Debe adjuntar ${maxSupportingDocuments} archivos de soporte, uno por cada documento requerido. Las evidencias adicionales deben agregarse en el apartado de especialidad.`,
    };
  }
  return { files: uniqueFiles, hasDuplicates: uniqueFiles.length < files.length };
};
